<template>
  <div class="details-view">
    <div class="main-content hrRealGPReport">
      <div class="section form-column" style="width: 1350px;">
        <el-form :inline="true" label-width="60px" label-position="center" style="margin-top: 5px;">
          <el-form-item label-width="100px" :label="'Copy Month'">
            <el-select v-model="copyMonth" no="copyMonth" style="width: 120px;" @change="onCopyMonthChagne">
              <el-option v-for="(item,index) in copyMonths" :key="index" :label="copyMonthLabelFun(item)" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="100px" :label="'Job Month'">
            <el-select v-model="accountMonth" no="accountMonth" style="width: 120px;" :disabled="true">
              <el-option v-for="(item,index) in accountMonthList" :key="index" :label="copyMonthLabelFun(item)" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')">
            <cargo-advance-select
              no="branchIds"
              :select-type="selectTypeNames.basic_data_Office"
              :multiple="true"
              :clearable="false"
              filterable
              :default-multiple-value="branchIds"
              tag-value="officeId"
              tag-name="code"
              :filter-tag-names="['englishName','chineseName','code']"
              :cache="false"
              :static-options="currentOfficeList"
              :placeholder="' '"
              style="width: 150px;"
              @parentCallBack="p=>{currentOfficeIdChange(p.value)}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Department')">
            <cargo-advance-select
              no="deptIds"
              :select-type="selectTypeNames.basic_data_Department"
              :multiple="true"
              filterable
              :default-multiple-value="deptIds"
              tag-value="departmentId"
              :tag-name="isZh ? 'chineseName' : 'englishName'"
              :filter-tag-names="['englishName','chineseName','code']"
              :cache="false"
              :static-options="currentDeptList"
              :placeholder="' '"
              style="width: 240px;"
              @parentCallBack="p=>{deptIds=p.value;}"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 15px!important;">
            <el-button no="dataExport" type="primary" @click="toDataExport()">{{ $t('CargoMsg.Cargo_DataExport') }}</el-button>
            <span style="font-size:13px;color:orange; margin-left: 25px;">{{ lastMonthlyDate }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { exportHrRealGPReport } from '@/api/clearing/pillReport'
import ColumnUtils from '@/utils/ColumnUtils'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheKeys, getFilterCacheList } from '@/utils/basicDataCache'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'TabHrRealGpReport',
  components: { cargoAdvanceSelect },
  props: {
    queryBranchList: { type: Array, default: () => [] },
    queryDeptIdList: { type: Array, default: () => [] },
    copyMonthList: { type: Array, default: () => [] },
    latestMonthlyDate: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      copyMonth: '',
      accountMonth: '', // Job Month
      accountMonthList: [],
      selectTypeNames: TYPE_NAMES,
      currentDeptList: [], // 部门列表
      branchIds: [], // 分公司IDS
      deptIds: [] // 部门IDS
    }
  },
  computed: {
    copyMonths() {
      return this.copyMonthList || []
    },
    lastMonthlyDate() {
      return 'Last archive date ' + ColumnUtils.dateTimeLabelFunc(this.latestMonthlyDate)
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    // 分公司列表
    currentOfficeList() {
      if (this.queryBranchList && this.queryBranchList.length > 0) {
        return this.queryBranchList
      }
      return this.$store.state.user.userInfo.currentUserOfficeList
    }
  },
  created() {

  },
  methods: {
    // 费用数据的财务月份，默认是等于Copy Month -2月。随Copy Month 联动，本期不可修改
    onCopyMonthChagne() {
      this.accountMonthList = []
      this.accountMonth = ''
      if (this.copyMonth) {
        const lastMonth = moment(this.copyMonth.slice(0, 4) + '-' + this.copyMonth.slice(4) + '-01').subtract(2, 'months').format('YYYYMM')
        console.log('lastMonth:', lastMonth)
        this.accountMonthList.push(lastMonth)
        this.accountMonth = this.accountMonthList[0]
      }
    },
    copyMonthLabelFun(data) {
      if (data && data.length === 6) {
        return data.substr(0, 4) + '-' + Number(data.substr(4)) + (this.$store.getters.language === 'zh' ? '月' : ' Month')
      }
      return data
    },
    toDataExport() {
      if (!this.copyMonth) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + ' Copy Month')
        return
      }
      if (!this.accountMonth) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + ' Job Month')
        return
      }
      //
      this.loading = getLoading()
      exportHrRealGPReport({ 'copyMonth': this.copyMonth, 'accountMonth': this.accountMonth, 'branchIds': this.branchIds, 'deptIds': this.deptIds }).then(res => {
        if (res.ok) {
          const h = this.$createElement
          this.$msgbox({
            title: this.$t('common.tips.prompt'),
            message: h('p', null, [
              h('p', { style: 'font-size: 18px;padding-bottom:5px' }, this.$t('PillReport.ExportingData')),
              h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
            ]),
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'success'
          })
        } else {
          this.$confirm(res.message, this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            canCloseModule: true,
            type: 'warning'
          })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 默认值
    setDefaultCondition() {
      if (this.copyMonths.length > 0) {
        this.copyMonth = this.copyMonths[0]
      }
      this.onCopyMonthChagne()
    },
    currentOfficeIdChange(val) {
      this.branchIds = val || []
      // 部门
      this.deptIds = []
      this.currentDeptList = []
      for (const branchId of this.branchIds) {
        const currentOffice = this.currentOfficeList.find(item => Number(item.officeId) === Number(branchId))
        const currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department_All, (item) => {
          return item.officeUuid === currentOffice.uuid && (this.queryDeptIdList.length === 0 || this.queryDeptIdList.includes(item.departmentId))
        }) || []
        if (currentDeptList.length !== 0) {
          this.currentDeptList.push(...currentDeptList)
        }
      }
    }

  }
}
</script>

<style lang="scss">

</style>
